import React from 'react';
import { weekString } from '../../Services/helpers';
import { usePreference } from '../../Data/Preference';
import Icon from '../../Components/Icons/Icon';
import Button from '../../Components/Button/Button';
import { useSession } from '../../Components/Session';
import { useDialogues } from '../../Components/Dialogues';

const RedesignPrompt = () => {
    const {setShowRedesign} = useSession();
    const thisWeek = weekString();
    const [hideRedesignPrompt, setHideRedesignPrompt] = usePreference('home:hideRedesignPrompt', null);
    const {info} = useDialogues();

    const hide = () => setHideRedesignPrompt(thisWeek);
    const showRedesign = () => {
        info({
            theme: 'primary',
            title: null,
            icon: 'Gift',
            message: <>
                <p>Thanks for trying out the new app design!</p>
                <p>We're still working on it, so we'd love your feedback - just drop Sid a message.</p>
                <p>You can switch back to the old design in the Tools menu.</p>
            </>
        });
        setShowRedesign(true);
    }

    if (hideRedesignPrompt === thisWeek) {
        return null;
    }

    return <div className="relative flex flex-col gap-4 rounded-lg shadow-md p-4 text-white bg-gradient-to-br from-brand to-brand-light text-center text-balance">
        <div className="absolute top-2 right-2">
            <Icon icon="XMark" className="fill-white/75 cursor-pointer" onClick={hide} />
        </div>
        <h1 className="text-xl font-bold">Ready for something new?</h1>
        <p>We've got a big update to the app, and you can try it now.</p>
        <p>It's easier to use, quicker to get around, and it's built to make your day-to-day work smoother.</p>
        <Button theme="light" className="text-brand" label="Try it out" onClick={showRedesign} />
    </div>
};

export default RedesignPrompt;
